import { CustomOccPrice, CustomProduct, Unit } from '@product/const';
import { Cart, CartModification, ConsignmentEntry, Occ, OrderEntry, VariantOption } from '@spartacus/core';

// TODO: Возможно требуется объединение с Item
export interface CustomOrderEntry extends OrderEntry {
  weight?: number;
  volume?: number;
  entryNumber?: number;
  basePrice?: CustomOccPrice;
  totalPrice?: CustomOccPrice;
  personalPrice?: CustomOccPrice;
  hasDiscount?: boolean;
  saleUnit?: Unit;
  transit?: boolean;
  product?: Partial<CustomProduct> & Pick<CustomProduct, 'code'>;
  unit?: string;
  quantity?: number;
  updateable?: boolean;
  forceInStock?: boolean;
  // Может ли быть на данные товар применена скидка
  canBeDiscounted?: boolean;
  manual?: boolean;
  requiredFullPayment?: boolean;
  status?: CustomEntryStatus;
  pickup?: PickupAdress;
  delivery?: DeliveryAdress;
}

export interface PickupAdress {
  warehouseName: string;
  warehouseCode: string;
  address: string;
  scheme?: string;
}

export interface DeliveryAdress {
  address: string;
  deliveryDate: string;
  timeInterval: {
    from: string;
    to: string;
  };
}

export interface CustomOrderEntryWithDelivery {
  deliveryType: DeliveryType;
  entry: CustomOrderEntry[];
}

export interface DeliveryType {
  type: DeliveryTypeEnum;
  pickup?: PickupAdress;
  delivery?: DeliveryAdress;
}

export enum DeliveryTypeEnum {
  Delivery = 'delivery',
  Pickup = 'pickup',
}

export interface CustomEntryStatus {
  code: string;
  name: string;
}

export interface CustomConsignmentEntry extends ConsignmentEntry {
  orderEntry?: CustomOrderEntry;
}

export interface BaseOptions {
  options: VariantOption;
}

export interface CustomCart extends Cart {
  appliedCertificates?: Certificate[];
  weight?: number;
  volume?: number;
  deliveryServicesCost?: CustomOccPrice;
  baseStoreId?: string;
  isInflow?: boolean;
  bonus?: {
    applyingAmountInfo?: {
      value: number;
      formattedValue: string;
    };
    assignedAmountInfo?: {
      value: number;
      formattedValue: string;
    };
    providingBonusForOrder?: ProvidingBonusForOrder;
    applyingResultCode?: string;
  };
  totalBonusDiscounts?: CustomOccPrice;
  organizationUid?: string;
}

export interface Certificate {
  code: string;
  // сколько есть
  freeAmount: string;
  // сколько скинет
  discount: string;
}

export interface OccCartModificationPayload {
  cartModifications: Occ.CartModification[];
  newBaseSiteId?: string;
}

export interface CartModificationPayload {
  cartModifications: CartModificationExtended[];
  newBaseSiteId?: string;
}

export interface CartModificationExtended extends CartModification {
  priceChanged?: boolean;
}

export interface CompareCartData {
  cartId?: string;
  newBaseSiteId?: string;
  persistCart?: boolean;
  userId?: string;
}

export interface Messages {
  messages: Message[];
}

export interface Message {
  messageFired: string;
}

export interface ProvidingBonusForOrder {
  message: string;
  steps: {
    bonusAmount: number;
    percent: number;
  }[];
}
